var React = require('react');

function MenuContact (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.1505 0.956421H0.867432L12.009 6.62727L23.1505 0.956421Z","fill":"white","key":0}),React.createElement("path",{"d":"M12.0089 9.16245L0 3.09131V14.0994C0 14.5664 0.467011 14.9 1.00074 14.9H23.017C23.5507 14.9 24.0177 14.5664 24.0177 14.0994V3.09131L12.0089 9.16245Z","fill":"white","key":1})]);
}

MenuContact.defaultProps = {"width":"25","height":"15","viewBox":"0 0 25 15","fill":"none"};

module.exports = MenuContact;

MenuContact.default = MenuContact;
